"use client";
import React, { useEffect, useState } from "react";
import { Form, Col } from "react-bootstrap";
import type { ModalInputProp } from "../../../class/frontend.schema";
export default function TextInput({
  value,
  label,
  placeholder,
  setValueFunc,
  invalid,
  invalidMsg,
  md = 12,
}: ModalInputProp) {
  const [textVal, setTextVal] = useState(value);
  const [invalidLocal, setInvalidLocal] = useState(false);
  const invalidMsgLocal = invalidMsg ?? `Please enter the [${placeholder}]!`;
  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value.toString().length > 0) {
      setInvalidLocal(false);
    } else {
      setInvalidLocal(true);
    }
    setTextVal(event.target.value);
    setValueFunc(event.target.value);
  };

  useEffect(() => {
    if (
      invalid !== undefined &&
      (invalid.toString() === "true" || invalid?.toString() === "false")
    ) {
      setInvalidLocal(invalid);
    }
  }, [invalid]);

  useEffect(() => {
    setTextVal(value as string);
  }, [value]);

  return (
    <Form.Group as={Col} md={md} controlId="eventModal.title">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        value={textVal as string}
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        isInvalid={invalidLocal}
      />
      <Form.Control.Feedback type="invalid">
        {invalidMsgLocal}
      </Form.Control.Feedback>
    </Form.Group>
  );
}
